import { use } from 'echarts/lib/echarts';
import { install } from './scatter3D/install';
use(install);